import { useState } from 'react';
import { toast } from 'react-toastify';
import { updateUserBookingDateAndPickupLocation } from '../../../api/userAPI';
import './cancelBooking.css';
import './stayRescheduleModal.css';

/*
 * Old My Bookings: a stay's new dates. The guest picks a new check-in,
 * check-out moves with it (same nights, rooms, guests). The server checks
 * free rooms, the stay's rules and that the price is the same
 * (backend controllers/user/stay/stayReschedule.js).
 */
const DAY = 24 * 60 * 60 * 1000;
const keyOf = (date) => new Date(date).toISOString().slice(0, 10);
const addDays = (key, n) => new Date(new Date(`${key}T00:00:00Z`).getTime() + n * DAY).toISOString().slice(0, 10);
const todayKey = () => keyOf(new Date(Date.now() + 5.5 * 60 * 60 * 1000));
const nice = (key) =>
    new Date(`${key}T00:00:00Z`).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    });

export default function StayRescheduleModal({ data, onClose, onChanged }) {
    const nights = Number(data?.nights) || 1;
    const oldIn = keyOf(data?.startDate);
    const oldOut = data?.endDate ? keyOf(data.endDate) : addDays(oldIn, nights);
    const [checkIn, setCheckIn] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const checkOut = checkIn ? addDays(checkIn, nights) : '';
    const nightsText = `${nights} night${nights === 1 ? '' : 's'}`;

    const close = (e) => {
        e?.stopPropagation();
        onClose();
    };

    const save = async (e) => {
        e.stopPropagation();
        if (!checkIn) {
            setError('Please pick the new check-in date.');
            return;
        }
        setBusy(true);
        setError('');
        try {
            const res = await updateUserBookingDateAndPickupLocation('camp', undefined, undefined, {
                bookingId: data?._id,
                checkIn
            });
            toast.success(res?.data?.message || 'Your stay dates are changed.');
            onClose();
            onChanged?.();
        } catch (err) {
            setError(err?.response?.data?.message || 'Couldn’t change the dates. Please try again.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className='modal' onClick={close}>
            <div className='modal-content stayResModal' onClick={(e) => e.stopPropagation()}>
                <p className='modal-title stayResTitle'>Change stay dates</p>
                <p className='stayResCurrent'>
                    Current: <strong>{`${nice(oldIn)} – ${nice(oldOut)}`}</strong> ({nightsText})
                </p>
                <label className='stayResField' htmlFor='oldStayNewIn'>
                    New check-in
                    <input
                        id='oldStayNewIn'
                        type='date'
                        value={checkIn}
                        min={addDays(todayKey(), 1)}
                        onChange={(e) => {
                            setCheckIn(e.target.value);
                            setError('');
                        }}
                    />
                </label>
                <p className='stayResCurrent'>
                    New check-out: <strong>{checkOut ? `${nice(checkOut)} (${nightsText})` : '—'}</strong>
                </p>
                <p className='stayResNote'>
                    Same rooms and guests. Dates can change up to 7 days before check-in, and only when the new dates
                    cost the same — otherwise cancel and book again.
                </p>
                {error && <p className='stayResError'>{error}</p>}
                <button onClick={save} className='confirm-btn stayResConfirm' disabled={busy || !checkIn}>
                    {busy ? 'Changing…' : 'Change dates'}
                </button>
                <button onClick={close} className='cancel-btn'>
                    Keep dates
                </button>
            </div>
        </div>
    );
}
